import script from "./roles-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./roles-modal.vue?vue&type=script&setup=true&lang=js"

import "./roles-modal.vue?vue&type=style&index=0&id=52f51c18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52f51c18"]])

export default __exports__